import {Web3Provider} from '@ethersproject/providers';

export const isWeb3Provider = (
  providerLike: Record<string, any>,
): providerLike is Web3Provider => providerLike instanceof Web3Provider;
